import * as React from "react";
const SvgPlayIconNoBg = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}) => <svg {...props} viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" aria-labelledby={titleId} aria-describedby={descId}>{desc ? <desc id={descId}>{desc}</desc> : null}{title ? <title id={titleId}>{title}</title> : null}<path d="M2.25 9.5V2.23205C2.25 1.46225 3.08333 0.981125 3.75 1.36602L10.0442 5L16.3385 8.63397C17.0051 9.01887 17.0051 9.98113 16.3385 10.366L10.0442 14L3.75 17.634C3.08333 18.0189 2.25 17.5378 2.25 16.768V9.5Z" fill="white" /></svg>;
export default SvgPlayIconNoBg;